module.exports = __webpack_public_path__ + "static/Geoffrey_Liu_headshot_lores-8d24a13237ec5762ff3419db9f40fbfc.png";